/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TBookingModel,
  IBookingRequest,
  IMappers,
  IBookingResponse,
  IBookingResponseError,
  TBookingResponse,
} from './types';

const defaultConfig: TBookingModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'pik-booking',
  pathApi: '/v1/booking/',
  hostType: 'api',
} as TBookingModel;

function createBookingModel(parameters: IBookingRequest): TBookingModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IBookingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IBookingRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchBooking<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IBookingOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TBookingResponse> {
  const { response, statusCode } = await httpApi.fetch(createBookingModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IBookingResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IBookingResponseError);
    }
  }

  return { response, statusCode } as TBookingResponse;
}

export { defaultConfig, createBookingModel, fetchBooking };
